<template>
  <v-app>
    <v-sheet
      v-if="loading"
      class="d-flex justify-center align-center"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-sheet>

    <template v-else>
      <Header />
      <router-view />
      <Footer />
      <CookieBanner />
      <WhatsappButton />
    </template>
  </v-app>
</template>

<script>
import Footer from "./components/shell/Footer.vue";
import Header from "./components/shell/Header.vue";
import CookieBanner from "./widgets/CookieBanner.vue";
import WhatsappButton from "./widgets/WhatsappButton.vue";
export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    informations() {
      return this.$rest(`informations`).item;
    },
    name() {
      return this.informations.name || ``;
    },
  },
  methods: {
    updateDocumentTitle() {
      document.title = this.name;
    },
  },
  watch: {
    $route() {
      this.updateDocumentTitle();
    },
    name() {
      this.updateDocumentTitle();
    },
  },
  mounted() {
    this.$rest(`contacts`).get({
      save: (state, data) => (state.item = data),
    });
    this.$rest(`informations`).get({
      save: (state, data) => (state.item = data),
    });
    this.$rest(`categories`).get();
    this.$rest(`slide-top`).get();
    this.$rest(`brands`).get();
    this.$rest(`social`).get({
      save: (state, data) => (state.item = data),
    });
    this.$rest(`about`)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  created() {
    this.updateDocumentTitle();
  },
  components: { Header, Footer, CookieBanner, WhatsappButton },
};
</script>

<style>
body {
  overflow-x: hidden;
}
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,700;1,400;1,500&display=swap");

.open-sans {
  font-family: "Open Sans", sans-serif;
}
@font-face {
  font-family: "PF Din Text Comp Pro";
  src: url(./fonts/PFDinTextCompPro-Regular.ttf);
  font-weight: normal;
}
@font-face {
  font-family: "PF Din Text Comp Pro Bold";
  src: url(./fonts/z-PFDinTextCompPro-Bold.ttf);
  font-weight: bold;
}
@font-face {
  font-family: "PF Din Text Comp Pro Italic";
  src: url(./fonts/PFDinTextCompPro-Italic.ttf);
  font-weight: normal;
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1194px !important;
  }
}
</style>
